<template>
    <div class="card">
        <div class="card-body">
            <div class="row mb-3">
                <div class="col-3 pr-1">
                    <VueCtkDateTimePicker formatted='ll' v-validate="'required'"  format="YYYY-MM-DD"  :range="true" name="date" :label="'সময়সীমা নির্বাচন করুন'" v-model="date" />
                    <p v-show="errors.has('date')" style="color:red">* {{ errors.first('date') }}</p>
                </div>
                <div class="col-3 pl-1">
                    <button @click.prevent="getResults()" style="height:41px;" class="btn btn-success my-2 my-sm-0" >Search</button>
                    <button @click.prevent="download()" style="height:41px;" class="btn btn-success my-2 my-sm-0 ml-2" >Download</button>
                </div>
                <div class="col-6 text-right">
                    <a class="btn btn-info" href="/report"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
                </div>
            </div>
            <div class="content">
                <div class="content_header">
                    <h3>চাঁদপুর পৌরসভা</h3>
                    <h4>এক নজরে বিভিন্ন মাসে মার্কেটের দাবি, আদায় ও আদায়ের হার</h4>
                </div>
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th rowspan="2">মাস</th>
                            <th rowspan="2">মোট দোকান</th>
                            <th colspan="4">মোট দাবি</th>
                            <th colspan="4">মোট আদায়</th>
                            <th colspan="3">আদায়ের হার (%)</th>
                            <th colspan="4">আদায়যোগ্য</th>
                        </tr>
                        <tr>
                            <td>বকেয়া</td>
                            <td>সারচার্জ</td>
                            <td>হাল</td>
                            <td>মোট</td>
                            <td>বকেয়া</td>
                            <td>সারচার্জ</td>
                            <td>হাল</td>
                            <td>মোট</td>
                            <td>বকেয়া</td>
                            <td>হাল</td>
                            <td>মোট</td>
                            <td>বকেয়া</td>
                            <td>সারচার্জ</td>
                            <td>হাল</td>
                            <td>মোট</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(val,key) in data" :key="key">
                            <td class="text-capitalize">{{ getMonthYear(val.date)}}</td>
                            <td>{{ val.dokan_shongkha}} </td>
                            <td class="text-right">{{ thousands_separators(val.dabi_due_amount)}}</td>
                            <td class="text-right">{{ thousands_separators(val.dabi_due_charge)}}</td>
                            <td></td>
                            <td class="text-right">{{ thousands_separators(val.dabi_total)}}</td>
                            <td class="text-right">{{ thousands_separators(val.adai_due_amount)}}</td>
                            <td class="text-right">{{ thousands_separators(val.adai_due_charge)}}</td>
                            <td></td>
                            <td class="text-right">{{ thousands_separators(val.adai_total)}}</td>
                            <td class="text-center">{{ getFormatedData(val.adai_parcent_bokeya)}}</td>
                            <td></td>
                            <td class="text-center">{{ getFormatedData(val.adai_parcent_total)}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import axios from 'axios';
import { mapGetters } from "vuex"
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

export default {
    name: "MarketDemandCalculation",
    data(){
        return {
            date:'',
            data:{},
        }
    },
    methods:{
        async loadContents(){
            var start = ''
            var end = ''
            if(this.date){
                start = this.date.start
                end = this.date.end
            }
            var data = {start,end};

            axios.post('/api/market-demand-calculation',data).then(response=>{
                this.data = response.data;

                this.data.forEach((value, index) => {
                    this.data[index]['adai_parcent_bokeya'] = value.adai_due_amount*100/value.dabi_due_amount;
                    this.data[index]['adai_parcent_total'] = value.adai_total*100/value.dabi_total;
                    this.data[index]['date'] = value.date
                });
                console.log(this.data);
            })
        },
        async getResults(){
            this.$validator.validateAll().then( result =>{
                if(result){
                    this.loadContents()
                }
            })
        },
        thousands_separators(num){
            var num_parts = num.toString().split(".");
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return num_parts.join(".");
        },
        getMonthYear(date){
            var monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
            var t = new Date(date);
            return monthNames[t.getMonth()] + ', ' + t.getFullYear();
        },
        getFormatedData(val) {
            return val.toFixed(2);
        },
        download(){
            this.$validator.validateAll().then( result =>{
                if(result){
                    let getUserInfo = JSON.parse(localStorage.getItem('user'))
                    let loggedUser = getUserInfo.name
                    var start = ''
                    var end = ''
                    var download = 'download'
                    if(this.date){
                        start = this.date.start
                        end = this.date.end
                    }
                    window.open(`${axios.defaults.baseURL}/api/market-demand-calculation?download=${download}&start=${start}&end=${end}&loggeduser=${loggedUser}`)
                }
            })
        },
    },
    mounted(){
        this.loadContents()
    },
    computed:{
    },
    components: {
        VueCtkDateTimePicker,
    }
}
</script>
<style scoped>
.content_header{ text-align: center; border:1px solid #999; padding:10px; margin-bottom: 15px;}
.content_header h3{ font-size: 20px;font-family: 'Kalpurush', Arial, sans-serif !important; margin:0;}
.content_header h4{ font-size: 16px;font-family: 'Kalpurush', Arial, sans-serif !important; margin:0;}
table{ border: 1px solid #999;font-family: 'Kalpurush', Arial, sans-serif !important;}
table th, td{ border: 1px solid #999;}
table thead tr th,table thead tr td{ text-align: center;}
.btn-info{ color: #fff; text-transform: capitalize; height: 42px; line-height: 42px; padding: 0rem 0.75rem;}
</style>
